import useHeader from "components/Header/Header-logic";
import React from 'react'

const WelcomeBanner = ({ classes }) => {
  const { userName } = useHeader();
  return (
      <div className={classes["welcome-message"]}>
        {`${userName ? `${userName}, ` : ''}What do you want to do today?`}
      </div>
  );
};

export default WelcomeBanner;
